import styles from "./RightContent.module.css";
import { Icon } from 'react-icons-kit'
import { userPlus } from 'react-icons-kit/fa/userPlus'
import {shield} from "react-icons-kit/fa/shield"

import {user} from 'react-icons-kit/fa/user'
import { check } from 'react-icons-kit/fa/check'
import { checkCircle } from 'react-icons-kit/fa/checkCircle'
import { useState } from "react";
const rigthtabs=
// ["Sign Up", "Verification", "Security Setup", "Personal Profile", "Confirmation"]
[{
  id:1,
  title:"Sign Up",
  icon:userPlus
},
{
  id:2,
  title:"Verification",
  icon:shield
},
{
  id:3,
  title:"Personal Profile",
  icon:user
},
{
  id:4,
  title:"Confirmation",
  icon:checkCircle
}
]
const RightContent = ({step=1}) => {


  const [activeTab, setActiveTab]=useState(step)
  return (
    <div className={styles.rightContent}>
      <div className={styles.frameFRAME}>
        <div className={styles.frameFrame}>
          <div className={styles.frameFrame1}>
            <img className={styles.subtractIcon} loading="eager" alt="" src="/subtract.svg" />
            <img className={styles.authnumberIcon} loading="eager" alt="" src="/authnumber.svg" />
            {/* <p className={styles.authnumberIcon}>AuthNumber</p> */}
          </div>
          <div className={styles.idCredential}>Identity & Credentials Management Platform</div>
        </div>
      </div>
      <div className={styles.pricingPlan}>
        <div className={styles.content}>
          {/* <div className={styles.pricingCardHeader}>
            <h2 className={styles.yourSelectedPlan}>Why AuthNumber</h2>
            <div className={styles.desc}>30-day free trial</div>
          </div> */}
          <div className={styles.list}>
            {rigthtabs.map((item, index)=>{
              const isActive= activeTab==item.id
              return(
            <div className={`${styles.rightTab} ${isActive ? styles.tab : ""}`} key={item.id}>
              <div className={styles.item1}>
              <Icon icon={item.icon} size={21}/>
              <div className={styles.featureLabelGoes}>{item.title}</div>
              </div>
            </div>)})}
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightContent;
